import React from "react";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { trackGoogleAdsConversion } from "../../utils/googleAds";

const FloatingWhatsApp = () => {
  const { lang } = useLanguage();

  const handleWhatsAppClick = () => {
    trackGoogleAdsConversion("whatsapp_click", {
      event_source: "floating_button",
      language: lang,
    });

    const defaultMessage =
      lang === "tr"
        ? "Merhaba, profinoks.com üzerinden ulaşıyorum. Ürünleriniz ve fiyat teklifi hakkında bilgi alabilir miyim?"
        : "Hello, I am contacting you via profinoks.com. May I get information and a quote for your products?";

    window.open(
      `https://api.whatsapp.com/send?phone=905306140705&text=${encodeURIComponent(
        defaultMessage
      )}`,
      "_blank"
    );
  };

  return (
    <aside aria-label="WhatsApp" className="fixed bottom-6 right-6 z-50 flex items-center group">
      <button
        type="button"
        onClick={handleWhatsAppClick}
        aria-label={lang === "tr" ? "WhatsApp ile Teklif Al" : "Get a Quote via WhatsApp"}
        className="flex items-center space-x-2.5 bg-[#25D366] hover:bg-[#20ba59] text-white px-4 py-3 rounded-full shadow-2xl shadow-green-600/40 hover:shadow-green-600/60 transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-green-400/50"
      >
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
        </span>
        <MessageCircle className="h-6 w-6 fill-white stroke-none shrink-0" />
        <span className="hidden sm:inline-block text-xs font-bold uppercase tracking-wider pr-1">
          {lang === "tr" ? "WhatsApp ile Teklif Al" : "Quote via WhatsApp"}
        </span>
      </button>
    </aside>
  );
};

export default FloatingWhatsApp;
